import { apiGet } from '@/store/api';

export async function getClient(clientId: string | number) {
  return apiGet(`clients/${clientId}`);
}
